import { Step, StepLabel, Stepper } from '@mui/material'
import { styled } from '@mui/system'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { registrationSliceActions, selectCurrentPage } from '../../../store/features/registration'
import AdminInfo from './AdminInfo'
import BusinessInfo from './BusinessInfo'
import PaymentInfo from './PaymentInfo'
import SubscriptionInfo from './Subscription'


const steps = ["Admin info",  "Business info", "Subscription & Payment", "Payment"]

export default function Index() {

    const currentPage = useSelector(selectCurrentPage)
    const dispatch = useDispatch()

    const handleStepperLinkOnClick = (index:number)=>{
        dispatch(registrationSliceActions.setCurrentPage(index))
    }

    useEffect(()=>{
        return ()=>{
            dispatch(registrationSliceActions.resetRegistration(""))
        }
        //eslint-disable-next-line
    },[])

    return (
        <div className='pattern_bg w-full h-full bg-white flex flex-col items-center'>

            <Stepper
                activeStep={currentPage}
                alternativeLabel
                className='45% my-20 mx-0 bg-white py-8 shadow-2xl'
            >
                {
                    steps.map((label,index)=>(
                        <Step key={label}
                            onClick={()=>handleStepperLinkOnClick(index)}
                            className="cursor-pointer"
                        >
                            <CustomStepLabel >{label}</CustomStepLabel>
                        </Step>
                    ))
                }
            </Stepper>

            {/* <AnimatePresence
            > */}
                {currentPage === 0 && <AdminInfo key="admin"  />}
                {currentPage === 1  && <BusinessInfo key="business"  />}
                {currentPage === 2 && <SubscriptionInfo key="sub_info"  />}
                {currentPage === 3 && <PaymentInfo key="pay_info"  />}
            {/* </AnimatePresence> */}

            
        </div>
    )
}




const CustomStepLabel = styled(StepLabel)(({theme})=>({
    '.Mui-active': {
        color: `${theme.palette.primary.main} !important`
    },
    '.Mui-completed': {
        color: `${theme.palette.primary.main} !important`
    },

}))